// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__DvF_X","noInteraction":"EventWrapper_noInteraction__2h-Th"};